import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchChoThanhToan } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";


export const SearchBarMobile = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchChoThanhToan); //dataSearchTaiSan dinh nghia o rootreducer

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchChoThanhToan({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Mã hợp đồng, họ và tên"
                      value={dataSearch.sSearch}
                      onChange={updateTextValue("tieusSearchde")}
                    />
                    <div className="form-control-position" >
                      <button type="button" onClick={onSearch} className="btn btn-info-new">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
